import { fetchPublicDispensaryCatalog as fetchInner } from "@the-drop/customer-shared/api/dispensary-catalog";
import { getCustomerApiBaseUrl } from "./api-base";

export function fetchPublicDispensaryCatalog() {
  return fetchInner(getCustomerApiBaseUrl());
}

export type {
  PublicDispensaryCatalogEntry,
  PublicDispensaryCatalogPayload,
} from "@the-drop/customer-shared/api/dispensary-catalog";
